import React, { useEffect, useState, useRef } from "react";
import { getRandomColor, createImageFromInitials } from "../Utils";
import Calendar from "../../assets/images/Calendar.svg";
import DatePicker from "react-datepicker";
import {Form,Button } from "react-bootstrap";
import Select from "react-select";
import CommentSection from "./Comment";
import { AiOutlineCaretLeft, AiOutlineCaretRight } from "react-icons/ai";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import DeleteIcon from "../../assets/images/trash.svg";
import AddColorIcon from "../../assets/images/plus-fill.svg";
import { useDispatch, useSelector } from "react-redux";
import { StepProgressBar } from "../Utils";
import { getTaskDetails, postStrategyFunctions } from "../../store/actions";
import ChevronRight from "../../assets/images/Chevron-right.svg";
import QuillEditor from "../../utils/QuillEditor";
import AddIcon from "../../assets/images/add.svg";
import UserProfile from "../../assets/images/user-profile.svg";
import Alert from "../Alert.js";
import Checkbox from "@mui/material/Checkbox";
import { resetExceptionError } from "../../store/actions/index.js";
import Info from "../../assets/images/info-black.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  postFolderManagerDelete,
  postLocalFolderManager,
  getLocalFolderManager,
  postLocalFolderManagerFileDelete,
  getXLExecutionPlanDetails,
} from "../../store/actions/index.js";
import { url } from "../../store/sagas/API.js";
import UploadImage from "../../assets/images/icon.svg";
import DuplicateTaskIcon from "../../assets/images/duplicate_task.svg";
import SheetImage from "../../assets/images/icons8-excel.svg";
import DocImage from "../../assets/images/icons8-microsoft-word.svg";
import PDFImage from "../../assets/images/pdf-svgrepo-com.svg";
import PPTImage from "../../assets/images/icons8-powerpoint.svg";
import TXTImage from "../../assets/images/icons8-text.svg";
import OtherImage from "../../assets/images/icons8-document.svg";
import NoDocImage from "../../assets/images/nodoc.svg";
import { motion } from "motion/react";
import { createStatus } from "./WorkboardProgress.js";
import { SlCalender } from "react-icons/sl";
import TaskUploadWindow from "./TaskUploadWindow.js";
import { FaFileImport } from "react-icons/fa";
function TaskSidebar({
  isNewTask,
  selectedTaskMilestoneId,
  breadcrumbs,
  empData,
  statusData,
  priorityData,
  mileStonesData,
  selectedTaskId,
  onClose,
  handleTaskDelete,
  isSubTaskVisible,
  setIsSubTaskVisible,
  handleDuplicateTaskClick,
  handleDTPopupShow,
  taskType,
  setTaskType,
  subTaskId,
  setSubTaskId,
  in_bireview,
}) {
  const dispatch = useDispatch();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [task, setTask] = useState([]);
  const [taskName, setTaskName] = useState("");
  const [assignedTo, setAssignedTo] = useState([]);
  const [loggedInUserPermission, setLoggedInUserPermission] = useState("write");
  const [desc, setDesc] = useState("");
  const [status, setStatus] = useState("");
  const [priority, setPriority] = useState("");
  const [milestone, setMilestone] = useState("");
  const [parentTaskId, setParentTaskId] = useState("");
  const [duedate, setDuedate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [comments, setComments] = useState("");
  const [subtasks, setSubtasks] = useState("");
  const [milestoneId, setMilestoneId] = useState("");
  const [collabarators, setCollabarators] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [isSubTaskSidebarOpen, setIsSubTaskSidebarOpen] = useState(false);
  const [currentTaskId, setCurrentTaskId] = useState("");
  const [isNewSubTask, setIsNewSubTask] = useState(false);
  const [currentUser, setCurrentUser] = useState("");
  const [attachment, setAttachment] = useState("");
  const [showTaskUploadFile, setShowTaskUploadFile] = useState(false);
  const [showNewTaskUploadFile, setShowNewTaskUploadFile] = useState(false);
  const [showSubTaskUploadFile, setShowSubTaskUploadFile] = useState(false);
  const [newUploadFileTaskId, setNewUploadFileTaskId] = useState("");
  const [newUploadFieSubTaskId, setNewUploadFileSubTaskId] = useState("");
  const [taskDueDatePermission, setTaskDueDatePermission] = useState("");
  const textareaRef = useRef(null);
  const [autoRepeat, setAutoRepeat] = useState(false);
  const [frequency, setFrequency] = useState(""); // Daily, Weekly, Monthly
  const [recurrenceStartDate, setRecurrenceStartDate] = useState("");
  const [recurrenceEndDate, setRecurrenceEndDate] = useState("");
  const [frequencyError, setFrequencyError] = useState(false);
  const [recurrenceRepeatDays, setRecurrenceRepeatDays] = useState([]); // For Weekly
  const [dateError, setDateError] = useState("");
  const today = new Date()
  const tomorrowDate = new Date(today);
  tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  const [isGeneratedTask, setIsGeneratedTask] = useState(false);
  const tomorrow = tomorrowDate.toISOString().split('T')[0];
  const [taskRecurringData, setTaskRecurringData] = useState(null);
  const milestoneChangedRef = useRef(false);

  const [subTaskUploadWindow, setSubTaskUploadWindow] = useState(false);

  // const [AddSubTaskVisible, setAddSubTaskVisible] = useState(false);
  const steps = ["Step 1", "Step 2", "Step 3", "Step 4", "Step 5", "Step 6"];
  const [progress, setProgress] = useState(0);
  const getSingleTaskDetails = useSelector(
    (state) => state.getSingleTaskDetails
  );
  const selectedSubMenuPermission = useSelector(
    (state) => state.selectedSubMenuPermission
  );
  const [fullScreenMode, setFullScreenMode] = useState(false);
  const postStrategyFunctionDetails = useSelector(
    (state) => state.postStrategyFunctionDetails
  );
  const customFilter = (option, searchText) => {
    if (option.data.label.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  const getProgress = (step) => {
    if (step === 0) {
      return 0;
    } else if (step === 20) {
      return 1;
    } else if (step === 40) {
      return 2;
    } else if (step === 60) {
      return 3;
    } else if (step === 80) {
      return 4;
    } else {
      return 5;
    }
  };
  useEffect(() => {
    if (postStrategyFunctionDetails && isNewTask) {
      if (postStrategyFunctionDetails.response) {
        setNewUploadFileTaskId(postStrategyFunctionDetails.response[0].key);
        setShowNewTaskUploadFile(true);
      }
    }
    if (postStrategyFunctionDetails && isSubTaskSidebarOpen && isNewSubTask) {
      if (postStrategyFunctionDetails.response) {
        setNewUploadFileSubTaskId(
          postStrategyFunctionDetails?.response[0]?.key
        );
        setShowSubTaskUploadFile(true);
      }
    }
    if (
      postStrategyFunctionDetails &&
      milestoneChangedRef.current &&
      !isNewTask &&
      !isSubTaskSidebarOpen
    ) {
      if (postStrategyFunctionDetails.response) {
        milestoneChangedRef.current = false;
        window.location.reload();
      }
    }
  }, [postStrategyFunctionDetails]);

  useEffect(() => {
    if (
      isNewTask === false &&
      getSingleTaskDetails &&
      getSingleTaskDetails.message &&
      getSingleTaskDetails.message.length > 0
    ) {
      setCurrentTaskId(getSingleTaskDetails.message[0].id);
      setTask(getSingleTaskDetails.message);
      setTaskDueDatePermission(getSingleTaskDetails.message[0].due_date_perm);
      setMilestoneId(getSingleTaskDetails.message[0].milestone_id);
      setTaskName(getSingleTaskDetails.message[0].name);
      setDesc(getSingleTaskDetails.message[0].description);
      setAttachment(getSingleTaskDetails.message[0].attachment);
      setCurrentUser(getSingleTaskDetails.message[0].emp_id);
      setAssignedTo(
        getSingleTaskDetails.message[0].assigned_to.filter(
          (employee) => employee.is_active
        )
      );
      const permissionForUser = getSingleTaskDetails.message[0].user_permission;
      setLoggedInUserPermission(permissionForUser);
      setTaskType(getSingleTaskDetails.message[0].task_type);
      setParentTaskId(getSingleTaskDetails.message[0].parent_task);
      setStatus({
        label: getSingleTaskDetails.message[0].status,
        value: getSingleTaskDetails.message[0].status,
      });
      setPriority({
        label: getSingleTaskDetails.message[0].priority,
        value: getSingleTaskDetails.message[0].priority,
      });
      const filteredData = mileStonesData?.filter(
        (item) => item.value === getSingleTaskDetails.message[0].milestone_id
      );
      if (filteredData && filteredData[0]) {
        setMilestone({
          label: filteredData[0].label,
          value: filteredData[0].value,
        });
      } else {
        console.error(
          `No match found for id: ${getSingleTaskDetails.message[0].milestone_id}`
        );
      }
      setDuedate(getSingleTaskDetails.message[0].due_date ||"");
      setStartDate(getSingleTaskDetails.message[0].start_date ||"");
      setComments(
        getSingleTaskDetails.message[0].comments.map((item) => ({
          ...item,
          icon: createImageFromInitials(
            30,
            item.comment_by[0].name,
            getRandomColor(item.comment_by[0].name)
          ),
        }))
      );
      setSubtasks(getSingleTaskDetails.message[0].subtasks);
      setCollabarators(getSingleTaskDetails.message[0].collaberators);
      setCurrentStep(getProgress(getSingleTaskDetails.message[0].progress));
      setProgress(getSingleTaskDetails.message[0].progress);
      setAutoRepeat(false);
      setFrequency("");
      setRecurrenceStartDate("");
      setRecurrenceEndDate("");
      setRecurrenceRepeatDays([]);
      setTaskRecurringData(null);
      setFrequencyError(false);
      setDateError("");
      setIsGeneratedTask(false);
    
    if (getSingleTaskDetails.message[0].recurring_data) {
      
      const rd = getSingleTaskDetails.message[0].recurring_data;
      
      console.log("task rec",getSingleTaskDetails.message[0]) 
     if (rd) {
      // Convert repeat_on_days → ["Monday", "Tuesday"]
      const mappedDays = rd.repeat_days||[]
        ? rd.repeat_days.map((d) => d.day || d)
        : [];

      const formattedData = {
        ...rd,
        repeat_days: mappedDays,
      };
      
     // const isParent=selectedTaskId==rd.reference_document;
     // setIsOriginalTask(isParent);
     const isChild = selectedTaskId !== rd.reference_document;
      setIsGeneratedTask(isChild);
      console.log("genearted task",isGeneratedTask);
      setTaskRecurringData(formattedData);
      setAutoRepeat(!rd.disabled);
      setFrequency(rd.frequency || "");
      setRecurrenceStartDate(rd.start_date || "");
      setRecurrenceEndDate(rd.end_date || "");
      setRecurrenceRepeatDays(mappedDays);
     
    }
     
    else {
      // Reset if no recurring data
      setAutoRepeat(false);
      setFrequency("");
      setRecurrenceStartDate("");
      setRecurrenceEndDate("");
      setRecurrenceRepeatDays([]);
      setTaskRecurringData(null);
      setFrequencyError(false);
      setDateError("");
 
    }
  }
else {
  setAutoRepeat(false);
  setFrequency("");
  setRecurrenceStartDate("");
  setRecurrenceEndDate("");
  setRecurrenceRepeatDays([]);
  setTaskRecurringData(null);
  setFrequencyError(false);
  setDateError("");
}}
 
  
  }, [getSingleTaskDetails]);

  useEffect(() => {
    if (taskName) {
      setShowTaskUploadFile(true);
      setShowNewTaskUploadFile(false);
    }
  }, [taskName]);

  useEffect(() => {
    if (isNewTask) {
      setShowNewTaskUploadFile(false);
      setTask("");
      setTaskName("");
      setPriority("");
      setStatus(statusData?.find((s) => s.value === "Open"));
      setDuedate("");
      setStartDate("");
      setAssignedTo([]);
      setProgress("");
      setDesc("");
      setComments([]);
      setCollabarators([]);
      setCurrentStep("");
      setSubtasks([]);
      setAutoRepeat(false);
      setFrequency("");
      setRecurrenceStartDate("");
      setRecurrenceEndDate("");
      setRecurrenceRepeatDays([]);
      setTaskRecurringData(null);
      setFrequencyError(false);
      setDateError("");
      setIsGeneratedTask(false);
      const filteredData = mileStonesData?.filter(
        (item) => item.value === selectedTaskMilestoneId
      );
      if (filteredData && filteredData[0]) {
        setMilestone({
          label: filteredData[0].label,
          value: filteredData[0].value,
        });
      }
      setLoggedInUserPermission("write");
    }
  }, [isNewTask]);
  useEffect(() => {
    if (isNewSubTask) {
      setLoggedInUserPermission("write");
      setShowNewTaskUploadFile(false);
      setTask("");
      setTaskName("");
      setPriority("");
      setStatus(statusData?.find((s) => s.value === "Open"));
      setDuedate("");
      setStartDate("");
      setAssignedTo([]);
      setProgress("");
      setDesc("");
      setComments([]);
      setCollabarators([]);
      setCurrentStep("");
      setSubtasks([]);
      setAutoRepeat(false);
      setFrequency("");
      setRecurrenceStartDate("");
      setRecurrenceEndDate("");
      setRecurrenceRepeatDays([]);
      setTaskRecurringData(null);
      setFrequencyError(false);
      setDateError("");
      setIsGeneratedTask(false);
     
      const filteredData = mileStonesData?.filter(
        (item) => item.value === selectedTaskMilestoneId
      );
      if (filteredData && filteredData[0]) {
        setMilestone({
          label: filteredData[0].label,
          value: filteredData[0].value,
        });
      }
    }
  }, [isNewSubTask]);
  // Function to handle the resizing
  const resizeTextarea = (e) => {
    e.target.style.height = "auto"; // Reset height
    e.target.style.height = `${e.target.scrollHeight}px`; // Set to scroll height
  };

  // Trigger resize when component mounts (for existing data)
  useEffect(() => {
    if (textareaRef.current) {
      resizeTextarea({ target: textareaRef.current });
    }
  }, [taskName]);

  useEffect(() => {
    if (isSubTaskSidebarOpen) {
      setTask("");
      setTaskName("");
      setPriority("");
      setStatus(statusData?.find((s) => s.value === "Open"));
      setDuedate("");
      setStartDate("");
      setAssignedTo([]);
      setProgress("");
      setDesc("");
      setComments([]);
      setCollabarators([]);
      setCurrentStep("");
      const filteredData = mileStonesData?.filter(
        (item) => item.value === selectedTaskMilestoneId
      );
      if (filteredData && filteredData[0]) {
        setMilestone({
          label: filteredData[0].label,
          value: filteredData[0].value,
        });
      }
    }
  }, [isSubTaskSidebarOpen]);
 
const handleAutoRepeatToggle = () => {
  if (autoRepeat) {
    //  Turn off the UI state
    setTaskRecurringData({
      frequency: frequency,
      start_date: recurrenceStartDate,
      end_date: recurrenceEndDate,
      repeat_days: recurrenceRepeatDays,
      disabled: true,
      reference_document: selectedTaskId
    });
    setAutoRepeat(false);
    setFrequency("");
    setRecurrenceStartDate("");
    setRecurrenceEndDate("");
    setRecurrenceRepeatDays([]);
    setFrequencyError(false);
    setDateError("");

    
  } else {
    //  If turning ON, restore previous values if they exist
    if (taskRecurringData) {
      setFrequency(taskRecurringData.frequency || "");
      setRecurrenceStartDate(taskRecurringData.start_date || "");
      setRecurrenceEndDate(taskRecurringData.end_date || "");
      setRecurrenceRepeatDays(taskRecurringData.repeat_days || []);
    }
    setAutoRepeat(true);
  }
};

  const handleSubTaskDelete = () => {
    Alert.warning({
      title:
        "Deleting a Functional Goal or Milestone or Parent Task will also delete all of its milestones and tasks and sub-tasks.",
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      preConfirm: (isConfirm) => {
        if (isConfirm) {
          let data = [
            {
              task_id: subTaskId,
              is_active: false,
            },
          ];
          dispatch(
            postStrategyFunctions(data, "sub_task", false, false, false, true)
          );
          onClose();
          dispatch(resetExceptionError());
        } else {
        }
      },
    });
  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "s") {
        event.preventDefault();
        if (loggedInUserPermission === "write") {
          handleSave();
        }
      }
      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    taskName,
    assignedTo,
    status,
    startDate,
    duedate,
    milestone,
    priority,
    progress,
    desc,
  ]);

  const handleSubtaskNav = () => {
    setIsSubTaskSidebarOpen(true);
    setSubTaskId("");
    setIsSubTaskVisible(false);
    setIsNewSubTask(true);
  };
  const handleSubtaskSideBar = (id) => {
    setIsSubTaskSidebarOpen(true);
    setSubTaskId(id);
    dispatch(getTaskDetails(id));
  };
  const handleStepClick = (stepIndex) => {
    setCurrentStep(stepIndex);
    setProgress(stepIndex * 20);
  };

  const handleFullScreen = () => {
    setFullScreenMode(true);
  };

  const handleSideNav = () => {
    setFullScreenMode(false);
  };

  const handleOwnerChange = (e) => {
    setAssignedTo(e);
  };

  const handleStatusSelect = (selectedOptions) => {
    setStatus(selectedOptions);
  };

  const handlePrioritySelect = (selectedOptions) => {
    setPriority(selectedOptions);
  };
  const handleMilestoneSelect = (selectedOptions) => {
    setMilestone(selectedOptions);
  };

  const handleMenuClick = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleDescOnChange = (content) => {
    setDesc(content);
  };

  const handleSave = () => {
    if (autoRepeat && !frequency) {
    setFrequencyError(true);
    // Optional: Scroll to the frequency field or show an alert
    return; // Stop execution here
  }
    if (autoRepeat&&!recurrenceEndDate){
      setDateError(true);
      return;
    }
    if (autoRepeat&&!recurrenceStartDate){
       setDateError(true);
       return;
    }
    if (isSubTaskSidebarOpen || taskType === "sub_task") {
      if (isNewSubTask) {
        let assignedToList = [];
        if (Array.isArray(assignedTo)) {
          assignedToList = assignedTo;
        } else {
          assignedToList = [assignedTo];
        }
        const requiredAssignedData = empData.map((item) => ({
          key: item.value,
          is_active: assignedToList.some(
            (selectedItem) => selectedItem.value === item.value
          ),
        }));
        let data = [
          {
            bi_id: localStorage.getItem("bi_id"),
            prod_id: localStorage.getItem("product_id"),
            parent_task_id: currentTaskId,
            task_name: taskName,
            assigned_to: requiredAssignedData,
            start_date: startDate,
            due_date: duedate,
            status: status.value || "",
            priority: priority.value || "",
            milestone: milestone.value || "",
            progress: progress,
            description: desc,
            collaberators: [],
            is_active: true,
            task_id: subTaskId,
          },
        ];
        dispatch(
          postStrategyFunctions(data, "sub_task", false, false, false, true)
        );
        // if (taskName) {
        //   onClose();
        // }
      } else {
        let assignedToList = [];
        if (Array.isArray(assignedTo)) {
          assignedToList = assignedTo;
        } else {
          assignedToList = [assignedTo];
        }
        const requiredAssignedData = empData.map((item) => ({
          key: item.value,
          is_active: assignedToList.some(
            (selectedItem) => selectedItem.value === item.value
          ),
        }));
        let data = [
          {
            bi_id: localStorage.getItem("bi_id"),
            prod_id: localStorage.getItem("product_id"),
            task_name: taskName,
            parent_task_id: parentTaskId,
            assigned_to: requiredAssignedData,
            start_date: startDate,
            due_date: duedate,
            status: status.value || "",
            priority: priority.value || "",
            milestone: milestone.value || "",
            progress: progress,
            description: desc,
            collaberators: [],
            is_active: true,
            task_id: currentTaskId,
            is_recurring: autoRepeat, 
            frequency: autoRepeat ? frequency : null,
            repeat_days: (autoRepeat && frequency === "Weekly") ? recurrenceRepeatDays : [],
            recurrence_end_date: autoRepeat ? recurrenceEndDate : null,
            recurrence_start_date:autoRepeat?recurrenceStartDate:null,
          },
        ];
        dispatch(
          postStrategyFunctions(data, "sub_task", false, false, false, true)
        );
        // if (taskName) {
        //   onClose();
        // }
      }
    } else {
      if (milestone?.value || selectedTaskMilestoneId) {
        let assignedToList = [];
        if (Array.isArray(assignedTo)) {
          assignedToList = assignedTo;
        } else {
          assignedToList = [assignedTo];
        }
        const requiredAssignedData = empData.map((item) => ({
          key: item.value,
          is_active: assignedToList.some(
            (selectedItem) => selectedItem.value === item.value
          ),
        }));
        // Check if milestone has changed for an existing task
        if (!isNewTask && milestone?.value && milestoneId && milestone.value !== milestoneId) {
          milestoneChangedRef.current = true;
        }
        let data = [
          {
            bi_id: localStorage.getItem("bi_id"),
            prod_id: localStorage.getItem("product_id"),
            parent_task_id: milestone.value || selectedTaskMilestoneId,
            task_name: taskName,
            assigned_to: requiredAssignedData,
            start_date: startDate,
            due_date: duedate,
            status: status.value || "",
            priority: priority.value || "",
            milestone: milestone.value || selectedTaskMilestoneId || "",
            progress: progress,
            description: desc,
            collaberators: [],
            is_active: true,
            task_id: selectedTaskId,
            is_recurring: autoRepeat, 
            frequency: autoRepeat ? frequency : null,
            repeat_days: (autoRepeat && frequency === "Weekly") ? recurrenceRepeatDays : [],
            recurrence_end_date: autoRepeat ? recurrenceEndDate : null,
            recurrence_start_date:autoRepeat?recurrenceStartDate:null,
          },
        ];
        dispatch(
          postStrategyFunctions(data, "task", false, false, false, true)
        );
      } else {
        Alert.warning({
          title: "Milestone is Mandatory",
          text: "Please select a milestone before saving the task.",
          icon: "warning",
          showConfirmButton: true,
        });
      }

      // if (taskName) {
      //   onClose();
      // }
    }
    // if (postStrategyFunctionDetails) {
    //   if (postStrategyFunctionDetails.response) {
    //     setNewTaskId(postStrategyFunctionDetails.response[0].key);
    //     setNewSubTaskId(postStrategyFunctionDetails.response[0].key);
    //   }
    // }
  };

  const logo = createImageFromInitials(
    30,
    localStorage.getItem("full_name"),
    getRandomColor(localStorage.getItem("full_name"))
  );

  const addComment = (newComment) => {
    setComments([...comments, newComment]);
  };

  const handleEditComment = (name, newContent) => {
    const updatedComments = comments.map((comment) =>
      comment.name === name ? { ...comment, content: newContent } : comment
    );
    setComments(updatedComments);
  };

  const handleDeleteComment = (name) => {
    const updatedComments = comments.filter((comment) => comment.name !== name);
    setComments(updatedComments);
  };
  return (
    <motion.div
      initial={{ x: "100%" }}
      animate={{ x: 1 }}
      exit={{ x: "100%" }}
      style={{
        width: fullScreenMode && "calc(100% - 50px)",
        zIndex: "100",
      }}
      className={"sidenav"}
    >
      <div
        className="gtm-sidebar-header"
        style={{
          borderBottom: "1px solid lightgrey",
          alignItems: "center",
        }}
      >
        <div
          style={{
            flex: "1",
            maxWidth: "70%",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            margin: "0",
            paddingTop: "4px",
            fontSize: "var(--sub-heading-font-size)",
            fontWeight: "var(--heading-font-weight)",
          }}
          title={breadcrumbs}
        >
          
          {isNewSubTask? "Add New Sub Task": isSubTaskSidebarOpen? "Edit Sub Task": breadcrumbs || ""}
        </div>

        { !isNewTask && !isSubTaskSidebarOpen && !isNewSubTask && taskType !== "sub_task" && loggedInUserPermission === "write" &&
        (
          <a
            className="bulk-add-btn"
            href="#"
            onClick={() => {
              setSubTaskUploadWindow(true);
              handleFullScreen();
            }}
          >
            {/* Bulk Add {type === "milestone" ? "Tasks" : "Milestones"} */}
            <FaFileImport size={18}/>
            
          </a>
        )

        }

        {loggedInUserPermission === "write" && !isNewTask && !isNewSubTask && (
          <a href="#" className="sideMenu" onClick={handleMenuClick}>
            <FontAwesomeIcon icon={faEllipsisH} />
          </a>
        )}
        {!fullScreenMode ? (
          <>
            <a href="#" className="fullscreen" onClick={handleFullScreen}>
              <AiOutlineCaretRight />
            </a>
          </>
        ) : (
          <>
            <a href="#" className="fullscreen" onClick={handleSideNav}>
              <AiOutlineCaretLeft />
            </a>
          </>
        )}
        {isMenuOpen && (
          <div className="menu">
            {(selectedSubMenuPermission === "write" ||
              selectedSubMenuPermission === "admin") && (
              <div className="Edit">
                <div
                  className="DeleteOption"
                  onClick={() =>
                    !isSubTaskSidebarOpen && taskType === "task"
                      ? handleTaskDelete()
                      : handleSubTaskDelete()
                  }
                >
                  <img
                    src={DeleteIcon}
                    width={"18px"}
                    style={{ marginRight: "10px" }}
                    alt="Edit Icon"
                  />
                  Delete
                </div>
              </div>
            )}
            <div style={{ cursor: "pointer" }}>
              <div
                className="duplicate-option-xlexecution-plan"
                onClick={() => {
                  handleDuplicateTaskClick(selectedTaskId, taskName);
                  onClose();
                  handleDTPopupShow();
                }}
              >
                <img
                  src={DuplicateTaskIcon}
                  width={"16px"}
                  style={{ marginRight: "10px" }}
                  alt="duplicate task icon"
                />
                Duplicate Task
              </div>
            </div>
          </div>
        )}
        <a
          href="#"
          className="closebtn"
          onClick={() => {
            onClose();
          }}
        >
          &times;
        </a>
      </div>
      <div className="gtm-sidebar-body">
        <div>
          <textarea
            ref={textareaRef}
            className="form-control"
            required
            rows={1}
            value={taskName}
            style={{
              padding: "6px 8px",
              marginLeft: "10px",
              width: "99%",
              border: "1px solid #ccc",
              borderRadius: "4px",
              marginBottom: "10px",
              fontSize: "var(--task-title-font-size)",
              resize: "none",
              overflow: "hidden",
              lineHeight: "1.5",
            }}
            placeholder={
              isSubTaskSidebarOpen
                ? "Write a Sub task name"
                : "Write a task name"
            }
            onChange={(e) => setTaskName(e.target.value.slice(0,140))}
            onInput={resizeTextarea} // Resize while typing
            // onInput={(e) => {
            //   // Reset the height first and then adjust based on content
            //   e.target.style.height = "auto";
            //   e.target.style.height = `${e.target.scrollHeight}px`; // Adjust to content height
            // }}
            disabled={loggedInUserPermission === "write" ? false : true}
          />
        </div>
        <div className="row">
          <div
            className="col-6"
            style={{
              alignItems: "center",
              marginBottom: "10px",
              zIndex: 800,
            }}
          >
            <div
              style={{
                marginLeft: "10px",
                marginRight: "20px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Owner
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Select
                required
                name="emp_id"
                // isMulti
                // hideSelectedOptions
                // allowSelectAll
                className="select-owner"
                 menuPortalTarget={document.body}   
                 styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                 placeholder={
                  <span style={{ fontSize: "var(--text-font-size)" }}>
                    Select Owner
                  </span>
                }
                value={assignedTo}
                options={empData}
                onChange={handleOwnerChange}
                isSearchable={true}
                filterOption={customFilter}
                getOptionLabel={(e) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img alt="" src={e.icon} />
                    <span
                      style={{
                        marginLeft: 5,
                        fontSize: "var(--sub-heading-font-size)",
                      }}
                    >
                      {e.label}
                    </span>
                  </div>
                )}
                isDisabled={loggedInUserPermission === "write" ? false : true}
                // menuPlacement="top"
              />
            </div>
          </div>
          <div
            className="col-6"
            style={{
              alignItems: "center",
              marginBottom: "10px",
              zIndex: 101,
            }}
          >
            <div
              style={{
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Status
            </div>
            <Select
              required
              className="status-select"
              menuPortalTarget={document.body}   
              styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              placeholder={
                <span style={{ fontSize: "var(--text-font-size)" }}>
                  Select Status
                </span>
              }
              value={status}
              options={statusData}
              onChange={handleStatusSelect}
              isSearchable={true}
              filterOption={customFilter}
              getOptionLabel={(e) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {/* <img alt="" src={e.icon} /> */}
                  <span
                    style={{
                      marginLeft: 5,
                      fontSize: "var(--sub-heading-font-size)",
                    }}
                  >
                    {e.label}
                  </span>
                </div>
              )}
              isDisabled={loggedInUserPermission === "write" ? false : true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div
              style={{
                marginLeft: "10px",
                textWrap: "nowrap",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Start Date
            </div>
           {/* Container for DatePicker with slight left margin and relative positioning(used to position calendar icon properly) */}
             <div style={{ marginLeft: "10px", width: "98%", position: "relative" }}>
              <DatePicker
                selected={startDate ? new Date(startDate) : null} // Convert stored string (YYYY-MM-DD) → JS Date object for DatePicker
                // When user selects/clears date:
                // Convert Date → string (YYYY-MM-DD) and update state
                onChange={(d) => setStartDate(d ? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0] : "")}
                dateFormat="yyyy-MM-dd"  // Display format inside input
                placeholderText="YYYY-MM-DD" // Placeholder when no date is selected
                portalId="root" // Renders calendar popup at root level to avoid overflow/clipping issue
                wrapperClassName="w-100" // Makes DatePicker take full width
                showMonthDropdown // Enable dropdowns for better UX (month & year selection)
                showYearDropdown
                dropdownMode="select"
                popperProps={{
                  strategy: "fixed"
                }}
                popperPlacement="bottom-start"
                popperClassName="custom-popper"
                customInput={  // Custom input field instead of default DatePicker input
                  <input className="form-control"
                    style={{
                      //  marginLeft: "10px",
                      width: "100%",
                      fontSize: "var(--sub-heading-font-size)",
                    }}
                    readOnly
                  />}
                    disabled={loggedInUserPermission === "write" ? false : true}
                 /> 
              <SlCalender size={14} color={startDate ? "#28a745" : "gray"} style={{ position: "absolute", right: "12px", top: "40%", transform: "translateY(-50%)", pointerEvents: "none", }}
              /></div>
          </div>
          <div className="col-6">
            <div
              style={{
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Due Date
            </div>
           <div style={{ marginLeft: "1px", width: "100%", position: "relative" }}>
             <DatePicker
                selected={duedate ? new Date(duedate) : null}
                onChange={(d) => setDuedate(d ? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0] : "")}
                dateFormat="yyyy-MM-dd"
                placeholderText="YYYY-MM-DD"
                wrapperClassName="w-100"
                showMonthDropdown
                portalId="root"
                showYearDropdown
                dropdownMode="select"
                popperProps={{
                  strategy: "fixed"
                }}
                popperPlacement="bottom-start"
                popperClassName="custom-popper"
                customInput={
                  <input   className="form-control due-date-select"
                   style={{
                width: "100%",
                fontSize: "var(--sub-heading-font-size)",
              }}
                    readOnly 
                />}
                 disabled={
                loggedInUserPermission === "write" &&
                (isNewTask || isNewSubTask || taskDueDatePermission === "write")
                  ? false
                  : true
              }
                />
              <SlCalender size={14} color={duedate ? "#28a745" : "gray"} style={{ position: "absolute", right: "12px", top: "40%", transform: "translateY(-50%)", pointerEvents: "none", }}
              />
            </div>
          </div>
        <div className="row">
         <div
            className="col-6"
            style={{
              marginBottom: "10px",
              zIndex: 100,
            }}
          >
            <div
              style={{
                marginLeft: "10px",
              //  marginBottom: 0,
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Priority
            </div>
            <div style={{ marginLeft: "10px" ,width: "100%" }}>
              <Select
                required
                className="priority-select"
                menuPortalTarget={document.body}
               styles={{
               menuPortal: (base) => ({ ...base, zIndex: 9999 }),}}
                placeholder={
                  <span style={{ fontSize: "var(--text-font-size)" }}>
                    Select Priority
                  </span>
                }
                value={priority}
                options={priorityData}
                onChange={handlePrioritySelect}
                isSearchable={true}
                filterOption={customFilter}
                getOptionLabel={(e) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                   
                    <span
                      style={{
                        marginLeft: 5,
                        fontSize: "var(--sub-heading-font-size)",
                      }}
                    >
                      {e.label}
                    </span>
                  </div>
                )}
                isDisabled={loggedInUserPermission === "write" ? false : true}/>
                </div>
               </div>
            <div className="col-6" style={{
              display: "flex", flexDirection: "column", marginTop: "26px",
              alignItems: "flex-start", marginBottom: "26px", paddingLeft: "15px"
            }}>
              {!isNewTask && !isNewSubTask && (

                (!isGeneratedTask || (isGeneratedTask && autoRepeat)) && (
                  <div style={{ display: "flex", alignItems: "center", gap: "6px", marginLeft: "8px",width:"100%" }}>
                    <Checkbox
                      id="autoRepeat"
                      checked={autoRepeat}
                      onChange={handleAutoRepeatToggle}
                      disabled={loggedInUserPermission !== "write" || isGeneratedTask}
                      size="small"
                      sx={{
                        padding: 0,
                        color: "#ccc",
                        "&.Mui-checked": { color: isGeneratedTask ? "#ccc" : "green" }
                      }}
                    />
                    <label
                      htmlFor="autoRepeat"
                      style={{
                        fontSize: "var(--sub-heading-font-size)",
                        fontWeight: "var(--heading-font-weight)",
                        cursor: isGeneratedTask ? "default" : "pointer",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Auto Repeat
                    </label>
                    {isGeneratedTask && autoRepeat &&loggedInUserPermission === "write" &&  (
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#888",
                          marginLeft: "6px",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        <OverlayTrigger
                          placement="top"
                          trigger={["hover", "focus", "click"]} // Works with both hovering and clicking
                          rootClose
                          overlay={
                            <Tooltip id="recurring-task-info">
                              This is a recurring task. Edit the original task to update future occurrences
                            </Tooltip>
                          }
                        >
                          <img
                            src={Info}
                            alt="info"
                            style={{
                              width: "13px",
                              height: "13px",
                              marginLeft: "-5px",
                              cursor: "pointer",
                            }}
                          />
                        </OverlayTrigger>
                      </span>
                    )}
                  </div>
                )
              )}
            </div>

          </div>
         {/* AUTO REPEAT CONFIGURATION SECTION */}
          {autoRepeat && (
            <>
              {/* Row 1: Recurring Start Date & End Date side-by-side */}
              <div className="row" style={{ marginBottom: "15px", position: "relative", zIndex: 800 }}>
                <div className="col-6">
                  <div style={{ marginLeft: "10px",width: "100%"  }}>
                    <Form.Group>
                      <Form.Label style={{ fontSize: "var(--sub-heading-font-size)", fontWeight: "var(--heading-font-weight)" }}>
                        Recurring Start Date{!isGeneratedTask && <span style={{ color: "red" }}>*</span>}
                      </Form.Label>
                      <div style={{ position: "relative", width: "100%" }}>
                        <DatePicker 
                          selected={recurrenceStartDate ? new Date(recurrenceStartDate) : null}
                          onChange={(d) => setRecurrenceStartDate(d ? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0] : "")}
                          dateFormat="yyyy-MM-dd"
                          placeholderText="YYYY-MM-DD"
                          wrapperClassName="w-100"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          portalId="root-portal"
                          popperPlacement="bottom-start"
                          minDate={new Date(today)}
                          customInput={
                            <input className="form-control"
                              style={{
                                width: "100%",
                                fontSize: "var(--sub-heading-font-size)",
                                border: (dateError && !recurrenceStartDate) ? "1px solid red" : "",
                              }}
                              readOnly
                            />
                          }
                          disabled={loggedInUserPermission !== "write" || isGeneratedTask}
                        />
                        <SlCalender size={14} color={recurrenceStartDate ? "#28a745" : "gray"}
                          style={{position: "absolute", right: "12px", top: "40%", transform: "translateY(-50%)", pointerEvents: "none"}}
                        />
                      </div>
                      {dateError && <div style={{ color: "red", fontSize: "12px" }}>{dateError}</div>}
                    </Form.Group>
                  </div>
                </div>

                <div className="col-6">
                  <div style={{ marginLeft: "12px",width: "102%"  }}>
                  <Form.Group>
                    <Form.Label style={{ fontSize: "var(--sub-heading-font-size)", fontWeight: "var(--heading-font-weight)" }}>
                    Recurring End Date {!isGeneratedTask && <span style={{ color: "red" }}>*</span>}
                    </Form.Label>
                    <div style={{ position: "relative", width: "100%" }}>
                      <DatePicker 
                        selected={recurrenceEndDate ? new Date(recurrenceEndDate) : null}
                        onChange={(d) => setRecurrenceEndDate(d ? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0] : "")}
                        dateFormat="yyyy-MM-dd"
                        placeholderText="YYYY-MM-DD"
                        wrapperClassName="w-100"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        portalId="root-portal"
                        popperPlacement="bottom-start"
                        minDate={new Date(tomorrow)}
                        customInput={
                          <input className="form-control"
                            style={{
                              width: "100%",
                              fontSize: "var(--sub-heading-font-size)",
                              border: (dateError && !recurrenceEndDate) ? "1px solid red" : "",
                            }}
                            readOnly
                          />
                        }
                        disabled={loggedInUserPermission !== "write" || isGeneratedTask}
                      />
                      <SlCalender size={14} color={recurrenceEndDate ? "#28a745" : "gray"}
                        style={{position: "absolute", right: "14px", top: "40%", transform: "translateY(-50%)", pointerEvents: "none"}}
                      />
                    </div>
                    {dateError && <div style={{ color: "red", fontSize: "12px" }}>{dateError}</div>}
                  </Form.Group>
                </div>
              </div>
              </div>

              {/* Row 2: Frequency & Repeat Days side-by-side */}
              <div className="row" style={{ marginBottom: "20px", position: "relative", zIndex: 800 }}>
                <div className="col-6">
                  <div style={{ marginLeft: "10px",width:"100%" }}>
                    <Form.Group>
                      <Form.Label style={{ fontSize: "var(--sub-heading-font-size)", fontWeight: "var(--heading-font-weight)" }}>
                        Frequency{!isGeneratedTask && <span style={{ color: "red" }}>*</span>}
                      </Form.Label>
                      <Select
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: frequencyError ? "red" : baseStyles.borderColor,
                            "&:hover": {
                              borderColor: frequencyError ? "red" : baseStyles.borderColor
                            }
                          }),
                        }}
                        placeholder="Select Frequency"
                        options={[
                          { label: "Daily", value: "Daily" },
                          { label: "Weekly", value: "Weekly" },
                          { label: "Monthly", value: "Monthly" },
                          { label: "Quarterly", value: "Quarterly" },
                          { label: "Half-yearly", value: "Half-yearly" },
                          { label: "Yearly", value: "Yearly" }
                        ]}
                        value={frequency ? { label: frequency, value: frequency } : null}
                        onChange={(e) => {
                          setFrequency(e.value);
                          setFrequencyError(false);
                        }}
                         isDisabled={loggedInUserPermission !== "write" || isGeneratedTask}
                      />
                    </Form.Group>
                  </div>
                </div>

                <div className="col-6">
                   <div style={{ marginLeft: "12px",width: "102%" }}>

                  {frequency === "Weekly" && (
                    <Form.Group>
                      <Form.Label style={{ fontSize: "var(--sub-heading-font-size)", fontWeight: "var(--heading-font-weight)" }}>
                        Repeat Days
                      </Form.Label>
                      <Select 
                        placeholder="Repeat on..."
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        options={[
                          { label: "Monday", value: "Monday" },
                          { label: "Tuesday", value: "Tuesday" },
                          { label: "Wednesday", value: "Wednesday" },
                          { label: "Thursday", value: "Thursday" },
                          { label: "Friday", value: "Friday" },
                          { label: "Saturday", value: "Saturday" },
                          { label: "Sunday", value: "Sunday" },
                        ]}
                        value={recurrenceRepeatDays.map((d) => ({ label: d, value: d }))}
                        onChange={(e) => setRecurrenceRepeatDays(e.map((d) => d.value))}
                        isMulti
                        isDisabled={loggedInUserPermission !== "write" || isGeneratedTask}
                      />
                    </Form.Group>
                  )}
                </div>
                
              </div>
              </div>
            </>
          )}
        </div>
        {loggedInUserPermission === "write" && taskType === "task"  && !isNewSubTask &&
        <div className="row">
          <div
            className="col-12"
            style={{
              marginBottom: "20px",
              zIndex: 3,
            }}
          >
            <div
              style={{
                marginLeft: "10px",
                marginRight: "25px",
                marginBottom: 0,
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Milestone<span className="required">*</span>
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Select
                required
                className="milestone-select"
                placeholder={
                  <span style={{ fontSize: "var(--text-font-size)" }}>
                    Select Milestone
                  </span>
                }
                value={milestone}
                options={mileStonesData}
                onChange={handleMilestoneSelect}
                isSearchable={true}
                filterOption={customFilter}
                getOptionLabel={(e) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {/* <img alt="" src={e.icon} /> */}
                    <span
                      style={{
                        marginLeft: 5,
                        fontSize: "var(--sub-heading-font-size)",
                      }}
                    >
                      {e.label}
                    </span>
                  </div>
                )}
                isDisabled={loggedInUserPermission === "write" ? false : true}
              />
            </div>
          </div>
        </div>
      }
        <div className="row">
          <div
            className="col-12"
            style={{
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              style={{
                marginLeft: "10px",
                marginRight: "20px",
                marginBottom: 0,
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Progress
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginLeft: "15px",
              }}
            >
              <StepProgressBar
                steps={steps}
                currentStep={currentStep}
                onStepClick={handleStepClick}
                selectedSubMenuPermission={loggedInUserPermission}
              />
              <div className="step-percentage">
                {(currentStep / (steps.length - 1)) * 100}%
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            marginLeft: "10px",
            marginRight: "30px",
            marginBottom: "0px",
            fontSize: "var(--sub-heading-font-size)",
            fontWeight: "var(--heading-font-weight)",
          }}
        >
          Description
        </div>
        <div style={{ margin: "10px 0px 10px 10px", height: "350px" }}>
          <QuillEditor
            value={desc}
            onChange={(content) => handleDescOnChange(content)}
            height={"350px"}
            disabled={loggedInUserPermission === "write" ? false : true}
          />
        </div>

        {subtasks && subtasks.length > 0 && (
          <div>
            <table>
              <thead>
                <tr>
                  <th
                    style={{
                      textAlign: "left",
                      paddingLeft: "10px",
                      paddingTop: "10px",
                      fontWeight: "var(--heading-font-weight)"
                    }}
                  >
                    SubTasks
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {subtasks.map((subtask) => (
                  <tr style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <td
                        key={subtask.id}
                        style={{ textAlign: "left", paddingLeft: "10px" }}
                      >
                        {subtask.name}
                      </td>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {subtask.due_date && <td>{subtask.due_date}</td>}
                        <td>{createStatus(subtask?.status)}</td>
                        <td>
                          {subtask.assigned_to.length > 0 &&
                          subtask.assigned_to.find((item) => item.is_active) ? (
                            <img
                              style={{ margin: "10px" }}
                              alt=""
                              src={createImageFromInitials(
                                30,
                                subtask.assigned_to.find(
                                  (item) => item.is_active
                                ).label,
                                getRandomColor(
                                  subtask.assigned_to.find(
                                    (item) => item.is_active
                                  ).label
                                )
                              )}
                            />
                          ) : (
                            <img
                              alt=""
                              src={UserProfile}
                              style={{ margin: "10px" }}
                            />
                          )}
                        </td>
                        <td>
                          {!in_bireview && (
                            <img
                              alt="chevronright"
                              src={ChevronRight}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleSubtaskSideBar(subtask.id);
                              }}
                            />
                          )}
                        </td>
                      </div>
                    </div>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div
          style={{
            textAlign: "left",
            paddingLeft: "5px",
            paddingBottom: "10px",
            display: isNewTask ? "none" : "flex",
          }}
        >
          {isSubTaskVisible && !in_bireview &&
            taskType !== "sub_task" &&
            loggedInUserPermission === "write" && (
              <button
                style={{
                  display: "flex",
                  border: "none",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  alignItems: "center",
                  marginTop: "10px",
                  color: "#0a5f59",
                  fontSize: "var(--sub-heading-font-size)",
                }}
                type="button"
                onClick={() => {
                  handleSubtaskNav();
                }}
              >
                <img
                  src={AddColorIcon}
                  width={16}
                  height={16}
                  style={{ marginRight: "5px" }}
                />
                Add Subtask
              </button>
            )}
        </div>
        {showTaskUploadFile && !isNewTask && !isSubTaskSidebarOpen ? (
          <>
            <div
              style={{
                fontSize: "var(--text-font-size)",
                fontWeight: "var(--heading-font-weight)",
                paddingLeft: "10px",
              }}
            >
              Please Upload relevant documents
            </div>
            <UploadFiles
              selectedSubMenuPermission={loggedInUserPermission}
              taskId={selectedTaskId}
              attachments={attachment ? attachment : ""}
            />
          </>
        ) : showNewTaskUploadFile && isNewTask ? (
          <>
            <div
              style={{
                fontSize: "var(--text-font-size)",
                fontWeight: "var(--heading-font-weight)",
                paddingLeft: "10px",
              }}
            >
              Please Upload relevant documents
            </div>
            <UploadFiles
              selectedSubMenuPermission={loggedInUserPermission}
              taskId={newUploadFileTaskId}
            />
          </>
        ) : isSubTaskSidebarOpen && !showSubTaskUploadFile && !isNewSubTask ? (
          <>
            <div
              style={{
                fontSize: "var(--text-font-size)",
                fontWeight: "var(--heading-font-weight)",
                paddingLeft: "10px",
              }}
            >
              Please Upload relevant documents
            </div>
            <UploadFiles
              selectedSubMenuPermission={loggedInUserPermission}
              taskId={subTaskId}
              attachments={attachment ? attachment : ""}
            />
          </>
        ) : isSubTaskSidebarOpen && showSubTaskUploadFile && isNewSubTask ? (
          <>
            <div
              style={{
                fontSize: "var(--text-font-size)",
                fontWeight: "var(--heading-font-weight)",
                paddingLeft: "10px",
              }}
            >
              Please Upload relevant documents
            </div>
            <UploadFiles
              selectedSubMenuPermission={loggedInUserPermission}
              taskId={newUploadFieSubTaskId}
            />
          </>
        ) : null}

        {isNewTask === false && isNewSubTask===false && (
          <div>
            <CommentSection
              currentUser={currentUser}
              logo={logo}
              fullScreenMode={fullScreenMode}
              taskId={selectedTaskId}
              commentsData={comments}
              onAddComment={addComment}
              onEditComment={handleEditComment}
              onDeleteComment={handleDeleteComment}
            />
          </div>
        )}
      </div>
      <div>
        <Button
          type="button"
          style={{
            position: "absolute",
            top: "8px",
            right: taskType === "task" ? "180px" : "150px",
            padding: "4px 10px",
            backgroundColor: "var(--button-primary-color)",
            fontSize: "var(--sub-heading-font-size)",
            border: "1px solid var(--button-primary-color)",
          }}
          onClick={() => {
            if (loggedInUserPermission === "write") {
              handleSave();
            }
          }}
          disabled={loggedInUserPermission === "write" ? false : true}
        >
          Save
        </Button>
      </div>
      {subTaskUploadWindow && (
          <TaskUploadWindow
            parentTaskName={selectedTaskId}
            parentSubject={taskName}
            childLabel={"Subtask"}
            onClose={() => setSubTaskUploadWindow(false)}
            onImported={() => window.location.reload()}
            setFullScreenMode = {setFullScreenMode}
          />
        )}
    </motion.div>
  );
}

const UploadFiles = ({ selectedSubMenuPermission, attachments, taskId }) => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);
  const [files, setFiles] = useState([]);

  const fetchpostLocalManagerData = useSelector(
    (state) => state.fetchpostLocalManagerData
  );
  const fetchpostLocalFolderManagerFileDelete = useSelector(
    (state) => state.fetchpostLocalFolderManagerFileDelete
  );

  useEffect(() => {
    if (fetchpostLocalManagerData && fetchpostLocalManagerData.status === 200) {
      if (fetchpostLocalManagerData.message) {
        const attachedToNames = fetchpostLocalManagerData.message.map(
          (item) => item.attached_to_name
        );
        if (attachedToNames.includes(taskId)) {
          setFiles((prevFiles) => [
            ...prevFiles,
            ...fetchpostLocalManagerData.message,
          ]);
        }
      }
    }
  }, [fetchpostLocalManagerData]);
  useEffect(() => {
    if (attachments && taskId) {
      setFiles(attachments);
    } else {
      setFiles("");
    }
  }, [attachments]);
  useEffect(() => {
    if (
      fetchpostLocalFolderManagerFileDelete &&
      fetchpostLocalFolderManagerFileDelete.status === 200
    ) {
      setFiles((prevFiles) => {
        const updatedFiles = prevFiles?.filter(
          (existingItem) =>
            !fetchpostLocalFolderManagerFileDelete.file_id.includes(
              existingItem.name
            )
        );
        return updatedFiles;
      });
    }
  }, [fetchpostLocalFolderManagerFileDelete]);

  const handleDeleteFile = (id) => {
    Alert.warning({
      title: "Warning",
      // html: ISError,
      text: "Are you sure do you want to delete the File?",
      icon: "warning",
      showCancelButton: true,
      preConfirm: (isConfirm) => {
        if (isConfirm) {
          dispatch(postLocalFolderManagerFileDelete(id));
          dispatch(resetExceptionError());
        }
      },
    });
  };

  const onButtonClick = () => {
    inputRef.current.click();
  };
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files);
    }
  };
  const [isMSDocsSend, setIsMSDocsSend] = useState(false);

  function handleFile(files) {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      setIsMSDocsSend(!isMSDocsSend);
      if (taskId) {
        dispatch(
          postLocalFolderManager(
            localStorage.getItem("bi_id"),
            localStorage.getItem("screen_id"),
            localStorage.getItem("main_screen_id"),
            file,
            "",
            "",
            localStorage.getItem("product_id"),
            taskId
          )
        );
      }
    }
  }
  const handleChange = function (e) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files);
    }
  };

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  return (
    <div>
      <div className="row">
        <div>
          <form
            id="form-file-upload"
            onDragEnter={
              selectedSubMenuPermission === "write" ||
              selectedSubMenuPermission === "admin"
                ? handleDrag
                : null
            }
            onSubmit={(e) => e.preventDefault()}
            style={{
              height: "60px",
              width: "80%",
              margin: "auto",
              marginBottom: "20px",
              marginTop: "10px",
            }}
          >
            <input
              ref={inputRef}
              type="file"
              id="input-file-upload"
              multiple={true}
              onChange={handleChange}
              disabled={
                selectedSubMenuPermission === "write" ||
                selectedSubMenuPermission === "admin"
                  ? false
                  : true
              }
            />
            <label
              id="label-file-upload"
              htmlFor="input-file-upload"
              className={dragActive ? "drag-active" : ""}
            >
              <div>
                <button
                  className="upload-button"
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default form submission
                    onButtonClick();
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor:
                      selectedSubMenuPermission === "write" ||
                      selectedSubMenuPermission === "admin"
                        ? "pointer"
                        : "default",
                    textDecoration:
                      selectedSubMenuPermission === "write" ||
                      selectedSubMenuPermission === "admin"
                        ? ""
                        : "none",
                  }}
                >
                  <div>
                    <img src={UploadImage} />
                  </div>
                  <span
                    style={{
                      color: "#0DA14B",
                      marginLeft: "5px",
                      fontSize: "var(--sub-heading-font-size)",
                      fontWeight: "var(--heading-font-weight)",
                    }}
                  >
                    Upload a file
                  </span>
                  <span
                    style={{
                      paddingLeft: "10px",
                      fontSize: "var(--sub-heading-font-size)",
                    }}
                  >
                    or drag and drop a file
                  </span>
                </button>
              </div>
            </label>
            {dragActive && (
              <div
                id="drag-file-element"
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
              ></div>
            )}
          </form>
          <div>
            {files.length > 0 ? (
              <>
                <table className="bordered-table-upload-files">
                  <thead
                    style={{
                      backgroundColor: "#F6F8FA",
                    }}
                  >
                    <tr>
                      <th>File</th>
                      <th>Modified</th>
                      <th>Modified By</th>
                      {selectedSubMenuPermission === "write" && <th>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {files.length > 0 &&
                      files.map((obj) => (
                        <tr key={obj.name}>
                          <td style={{ textAlign: "left" }}>
                            <a
                              href={url + obj.file_url}
                              target="_blank"
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                textDecoration: "none",
                              }}
                            >
                              <img
                                src={
                                  obj.img
                                    ? url + obj.img
                                    : obj.file_name.split(".").pop() ===
                                        "xls" ||
                                      obj.file_name.split(".").pop() ===
                                        "xlsx" ||
                                      obj.file_name.split(".").pop() === "csv"
                                    ? SheetImage
                                    : obj.file_name.split(".").pop() === "pdf"
                                    ? PDFImage
                                    : obj.file_name.split(".").pop() ===
                                        "doc" ||
                                      obj.file_name.split(".").pop() === "docx"
                                    ? DocImage
                                    : obj.file_name.split(".").pop() === "ppt"
                                    ? PPTImage
                                    : OtherImage
                                }
                                style={{
                                  width: 25,
                                  height: 25,
                                }}
                              />
                              <label
                                style={{
                                  color: "black",
                                  cursor: "pointer",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  fontSize: "var(--text-font-size)",
                                  width: "300px",
                                }}
                              >
                                {obj.file_name}
                              </label>
                            </a>
                          </td>
                          <td style={{ fontSize: "var(--text-font-size)" }}>
                            {obj.modified}
                          </td>
                          <td style={{ fontSize: "var(--text-font-size)" }}>
                            {obj.modified_by}
                          </td>
                          {selectedSubMenuPermission === "write" && (
                            <td>
                              <span
                                className="folder-managementicons"
                                title="Delete"
                                onClick={() => handleDeleteFile(obj.name)}
                              >
                                <img src={DeleteIcon} width={14} />
                              </span>
                            </td>
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </>
            ) : (
              <>
                <label
                  style={{
                    fontSize: "var(--sub-heading-font-size)",
                    fontWeight: "var(--heading-font-weight)",
                    marginLeft: "10px",
                  }}
                >
                  All Documents
                </label>
                <div style={{ textAlign: "center" }}>
                  <img src={NoDocImage} />
                  <div>
                    <label
                      style={{
                        fontSize: "var(--sub-heading-font-size)",
                        fontWeight: "var(--heading-font-weight)",
                      }}
                    >
                      No Documents
                    </label>
                  </div>
                  <div>
                    <label
                      style={{
                        fontSize: "var(--sub-heading-font-size)",
                      }}
                    >
                      Uploaded documents will appear here
                    </label>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskSidebar;